module.exports = __webpack_public_path__ + "img/small.d32bbba8.jpg";